import {
  IHolidayFilterOptionData,
  IHolidaySearchResult,
} from "../types/holiday-search-type";

function parsePrice(value: string | number | null | undefined): number | null {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === "string") {
    const normalized = Number(value.replaceAll(",", ""));
    if (Number.isFinite(normalized)) {
      return normalized;
    }
  }

  return null;
}

export function getHolidayDurationBucket(duration: number) {
  if (duration <= 3) {
    return "1-3";
  }

  if (duration <= 6) {
    return "4-6";
  }

  return "7+";
}

export function extractHolidayFilterData(
  results: IHolidaySearchResult[],
): IHolidayFilterOptionData {
  const prices = results
    .map((item) => parsePrice(item.price))
    .filter((value): value is number => typeof value === "number");

  const minPrice = prices.length ? Math.min(...prices) : 0;
  const maxPrice = prices.length ? Math.max(...prices) : 0;

  const holidayTypes = Array.from(
    new Set(results.map((item) => item.holiday_type).filter(Boolean)),
  ).sort((a, b) => a.localeCompare(b));

  const holidayFor = Array.from(
    new Set(results.map((item) => item.holiday_for).filter(Boolean)),
  ).sort((a, b) => a.localeCompare(b));

  const durations = Array.from(
    new Set(
      results
        .map((item) => getHolidayDurationBucket(Number(item.duration)))
        .filter(Boolean),
    ),
  ).sort((a, b) => a.localeCompare(b));

  return {
    minPrice,
    maxPrice,
    holidayTypes,
    holidayFor,
    durations,
  };
}
